import TextViewer from "../components/TextViever";

const Contact = () => {
  return <TextViewer obszar="contact" />;
};

export default Contact;
